module.exports = __webpack_public_path__ + "img/zone100150.d7e1a854.png";